module.exports = __webpack_public_path__ + "static/media/kv-th.5ed29724.jpg";